// import moment from 'moment';
import { date as dateTransform } from '~/network/mainClient/common/transforms/requests';
import { updateAdminRoundIssueInfo } from '~/network/mainClient/estates/requests';

// admin estate info field
export const info = (data) => {
    if (!data) {
        return null;
    }
    return {
        id: data.id,
        max_loan_term: dateTransform(data.maxLoanTerm),
        share_capital: data.shareCapital,
    };
};

export const adminIssueItem = (data) => {
    const fields = {
        status: data.status,
    };
    return fields;
};

export const adminEstateItem = (data) => {
    const fields = {
        name: data.title,
        address: data.address,
        description: data.description,
        total_cost: data.totalValue,
        current_dividend_profitability: data.currentDividendProfitability,
        target_profitability: data.targetDividendProfitability,
        target: data.target,
        year_percent: data.yearPercent,
        cap_rate: data.capRate,
        gba: data.totalSquare,
        gla: data.rentableSquare,
        occupancy: data.occupancy,
        minimum_investment_amount: data.minimalInvestmentAmount,
        trade_min_investment_amount: data.tradeMinInvestmentAmount,
        initial_balance: data.initialBalance,
        annual_indexing: data.annualIndexing,
        is_active: data.isActive,
        status: data.status,
        investment_types: data.availableInvestmentTypes,
        juridical_info: {
            organization_name: data.orgTitle,
            organization_address: data.orgAddress,
            legal_address: data.orgJurAddress,
            mailing_address: data.orgMailAddress,
            ogrn: data.ogrn,
            okved: data.okved,
            organization_name_acronym: data.organizationNameAcronym,
            inn: data.inn,
            bank_name: data.bankTitle,
            kpp: data.kpp,
            bik: data.bik,
            bank_account: data.bankAccount,
            cadastral_account: data.cadastralAccount,
            date_registration: dateTransform(data.registrationDate),
        },
    };
    // passport_number: data.passportNumber,
    // passport_date: moment(data.passportDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
    // subdivision_name: data.passportIssuer,
    // subdivision_code: data.passportIssuerCode,
    // registration_address: data.passportAddress,
    // birth_date: moment(data.passportBirthDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
    if (data.type?.id && parseInt(data.type.id, 10) !== -1) {
        fields.type = data.type.id;
    }
    if (data.info) {
        fields.info = info(data.info);
    }
    const hasImage = data.image && typeof data.image !== 'string';
    const hasDocument = data.document && typeof data.document !== 'string';
    if (hasImage) {
        fields.image = data.image;
    }
    if (hasDocument) {
        fields.document_title = data.documentTitle;
        fields.document = data.document;
    }
    if (hasImage || hasDocument) {
        const result = new FormData();
        // fields.juridical_info = JSON.stringify(fields.juridical_info);
        for (const key in fields) {
            if (fields[key]) {
                result.append(key, fields[key]);
            }
        }
        return result;
    } else {
        return fields;
    }
};

export const adminEstateRequestsList = ({ campaignIndex, ...data }) => {
    return {
        investment_round: campaignIndex,
        ...data,
    };
};
